import { api } from './index'

export type PointsMultiplier = {
  id: number
  date_range_starts_on: string | null
  date_range_ends_on: string | null
  factor: number
  points_experience_id: number
}

export type PointsMultiplierPayload = Partial<PointsMultiplier>

export type PointsExpiration = {
  amount: number
  expiration_date: string
  status: 'expired' | 'scheduled' | 'reversed'
  id?: string
}

export type PointsExpirationsParams = {
  userIdentifier: string
  page?: number
  per_page?: number
}

export type PointsExpirationsPagination = {
  total_pages: number
  per_page: number
  current_page: number
  total_count: number
}

export const pointsApi = api.injectEndpoints({
  endpoints: builder => ({
    getMultipliers: builder.query<
      { points_multipliers: PointsMultiplier[] },
      number
    >({
      query: pointsExperienceId => ({
        url: 'points_multipliers',
        params: { points_experience_id: pointsExperienceId },
      }),
      providesTags: ['PointsMultiplier'],
    }),
    createMultiplier: builder.mutation<
      PointsMultiplier,
      PointsMultiplierPayload
    >({
      query: payload => ({
        url: 'points_multipliers',
        method: 'POST',
        body: {
          points_multiplier: payload,
        },
      }),
      invalidatesTags: ['PointsMultiplier'],
    }),
    updateMultiplier: builder.mutation<
      PointsMultiplier,
      PointsMultiplierPayload
    >({
      query: payload => ({
        url: `points_multipliers/${payload.id}`,
        method: 'PATCH',
        body: {
          points_multiplier: payload,
        },
      }),
      invalidatesTags: ['PointsMultiplier'],
    }),
    deleteMultiplier: builder.mutation<undefined, number>({
      query: id => ({
        url: `points_multipliers/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['PointsMultiplier'],
    }),
    getPointsExpirations: builder.query<
      {
        expirations: PointsExpiration[]
        pagination: PointsExpirationsPagination
      },
      PointsExpirationsParams
    >({
      query: ({ userIdentifier, page, per_page }) => ({
        url: `users/${userIdentifier}/points_expirations`,
        params: { page, per_page },
      }),
      providesTags: ['PointsExpirations'],
    }),
    reversePointsExpiration: builder.mutation<
      undefined,
      { userIdentifier: string; transactionId: string }
    >({
      query: ({ userIdentifier, transactionId }) => ({
        url: `users/${userIdentifier}/points_expirations/reverse`,
        method: 'POST',
        body: { transaction_id: transactionId },
      }),
      invalidatesTags: ['PointsExpirations'],
    }),
  }),
})
